import React from 'react';
import { Box } from '@mui/material';
import HeroSection from './HeroSection';
import Festival2026 from './festival/Festival2026';
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();
    // Fecha del evento: 6 de febrero de 2026, 00:00
    const targetDate = '2026-02-06T00:00:00';

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                boxSizing: 'border-box',
                gap: "10px",
            }}
        >
            {/* Sección Hero con video y countdown */}
            <HeroSection targetDate={targetDate} />

            {/* Sección de Festival 2026 - Datos dinámicos desde carpetas */}
            <Festival2026 />

            {/* Banner Certamen Nuevos Valores */}
            <Box
                component="img"
                src="/certamen_home.png"
                alt="Certamen Nuevos Valores"
                onClick={() => navigate('/nuevos-valores')}
                sx={{
                    width: '100%',
                    cursor: 'pointer',
                    display: 'block',
                    mt: { xs: '20px', md: '40px' },
                    mb: '20px'
                }}
            />
        </Box>
    );
}
